import React from 'react';
import {Styles} from '../../../config/design/styles';
import { withStyles } from '@material-ui/core/styles';
import RichEditor from "../../components/editor/RichEditor";
import {Translate} from "../../../config/Translate";
import TextField from "@material-ui/core/TextField/TextField";
import validator from "validator";
import axios from "axios";
import {defaultVariabls} from "../../../config/index";
import Thumbnail from "../fileManager/Components/Thumbnail";
import {withRouter} from "react-router-dom";
import { withSnackbar } from 'notistack';
import LoadingButton from "../../components/elements/LoadingButton";
import SubTitle from "../../components/elements/SubTitle";
import AppAnimate from "../../components/AppAnimate";
import AppCard from "../../components/layouts/components/AppCard";
import AllInboxRoundedIcon from '@material-ui/icons/AllInboxRounded';
import Keywords from "../../components/fields/keywords"
import IconButton from "@material-ui/core/IconButton/IconButton";
import Grid from "@material-ui/core/Grid/Grid";
import FieldCounter from "../../components/elements/FieldCounter";
import Typography from "@material-ui/core/Typography/Typography";
import CategoryHolderPro from "../../components/fields/CategoryHolderPro";
import {setStore} from "trim-redux";
import FormControlLabel from "@material-ui/core/FormControlLabel/FormControlLabel";
import Switch from "@material-ui/core/Switch/Switch";
import Alert from "@material-ui/lab/Alert/Alert";
import AppCardLoaderFields from "../../components/Skeletons/AppCardLoaderFields";
import Hidden from "@material-ui/core/Hidden/Hidden";
class MakeContent extends React.Component {

    constructor(props){
        super(props);
        this.ThumbChild = React.createRef();
        this.EditorChild = React.createRef();

    }
    state = {
        fields:{
            title:"",
            description:"",
        },
        content:{
            HTML: '',
            RAW: null,
            PlainText: ''
        },
        thumbnail: 1,
        errors:{},
        keywords:[],
        categories:[],
        loading: true,
        SubmitLoading: false,
        publish: true,
        id:this.props.match.params.id,
        editMode:false
    };
    classes = this.props.classes;
    componentDidMount(){
        if(this.state.id){
            this.setState({
                editMode:true
            })
            this.loadData();
        }else{
            this.setState({
                loading:false
            })
        }
    }
    componentDidUpdate(prevProps){
        if(this.state.id !== this.props.match.params.id){
            this.setState({
                id: this.props.match.params.id
            })
        }
    }
    handleThumbImage(id){
        this.setState({
            thumbnail: id
        })
    }
    handleChangePublish(){
        this.setState({
            publish: !this.state.publish,
        })
    }
    async loadData(){
        let loginToken = localStorage.getItem('ACT');
        if(loginToken !== null){
            let config = {
                headers: {
                    Accept: 'application/json',
                    Authorization: `Bearer ${loginToken}`
                }
            };
            await axios.get(`${defaultVariabls.url}/content/get/${this.state.id}`, config)
                .then(response => {
                    this.setState({
                        fields: {
                            title: response.data.title,
                            description: response.data.description,
                        },
                        thumbnail: response.data.thumbnail.id,
                        content: {
                            HTML: response.data.html,
                            RAW: response.data.raw,
                        },

                    })
                    let categoriesTemp=[];
                    let keywordsTemp=[];
                    response.data.categories.map(item => {
                        categoriesTemp.push(item.id)
                        return true
                    })
                    response.data.keywords.map(item => {
                        keywordsTemp.push(item.name);
                        return true
                    });
                    this.setState({
                        categories: categoriesTemp,
                        keywords: keywordsTemp,
                        loading: false
                    })
                }).catch(error => {
                    this.setState({
                        loading:false
                    })
                })
        }else {
            setStore({
                isAuth : false,
                user : null,
            });
            this.setState({
                loading:false
            })
        }
    }
    handleChange(e){
        let {errors,fields} = this.state;
        let target = e.target;
        fields[target.name] = target.value;
        errors[target.name] = "";
        this.setState({fields});
    }

    handleValidation(callback){
        let { fields } = this.state;
        let errors = {};
        let formIsValid = true;

        //title
        if(validator.isEmpty(fields.title)){
            formIsValid = false;
            errors['title'] = Translate.emptyField;
        }

        //Description
        if(fields.description !== null ) {
            if (fields.description.length > 150) {
                formIsValid = false;
                errors['description'] = Translate.maxLength150;
            }
        }
        if(!formIsValid){
            this.props.enqueueSnackbar(Translate.someFieldsHasError, {
                variant: 'warning',
            });
            this.setState({
                errors,
                SubmitLoading:false,
            })
        }
        return callback(formIsValid)
    }

    handleRequest(){
        let { fields,thumbnail,content,keywords,categories,publish,id,editMode} = this.state;
        let data = new FormData();
        data.append('title', fields.title);
        data.append('html', content.HTML);
        data.append('raw', content.RAW);
        data.append('plainText', content.PlainText);
        data.append('id', id ? id : 0);
        data.append('description', fields.description);
        data.append('thumbnail', thumbnail);
        data.append('categories',  JSON.stringify(categories));
        data.append('keywords',  JSON.stringify(keywords));
        data.append('publish',  publish ? 1 : 0);

        let loginToken = localStorage.getItem('ACT');
        let config = {
            headers: {
                Accept: 'application/json',
                Authorization: `Bearer ${loginToken}`
            }
        };
        axios.post(`${defaultVariabls.url}/content/make`, data, config)
            .then(response => {
                this.props.enqueueSnackbar(editMode ? Translate.contentEdited : Translate.contentAdded, {
                    variant: 'success',
                });
                this.setState({
                    loading:false,
                    SubmitLoading: false,
                });
                if(!this.state.editMode){
                    this.props.history.push(`/manage/contents`);

                }
            })
            .catch(error => {
                console.log(error.response)
                this.props.enqueueSnackbar(editMode ?  Translate.contentEditingFailed : Translate.contentAddingFailed, {
                    variant: 'error',
                });
                this.setState({
                    loading:false,
                    SubmitLoading: false,
                });
            });

    }
    handleClickDescription(){
        let {fields,content} = this.state;
        if(fields['description'] === ''){
            fields['description'] = content.PlainText === null ? null : content.PlainText.slice(0, 150);
            this.setState({fields})
        }
    }
    handleSubmit(e){
        this.setState({
            SubmitLoading: true
        })
        e.preventDefault();
        this.handleValidation((valid) =>{
            if(valid) {
                this.handleRequest();
            }
        });
    }

    handleOutPut(code){
        this.setState({
            content:code
        })
    }
    handleCategoryHolder(categories){
        this.setState({categories})
    }
    render(){
        let {fields, errors,SubmitLoading,keywords,thumbnail,categories,content,editMode,publish} = this.state;
        return (
            <AppAnimate animation='transition.slideUpIn' delay={200} title={editMode ? Translate.editContent : Translate.makeContent}>
            {

                        <Grid container spacing={2} justify="center">
                            <Grid item xs={12} md={8} lg={9}>
                                <AppCard
                                    title={editMode ? Translate.editContent : Translate.makeContent}
                                    action={
                                        <IconButton><AllInboxRoundedIcon color="primary"/></IconButton>
                                    }>
                                    {
                                        this.state.loading ? <AppCardLoaderFields/> :
                                            <Grid container spacing={2} justify="center" alignItems="center">
                                                {
                                                    editMode &&
                                                    <Grid item xs={12}>
                                                        <Alert
                                                            severity="info"
                                                            action={
                                                                <FormControlLabel
                                                                    style={{marginRight:10}}
                                                                    control={
                                                                        <Switch
                                                                            checked={publish}
                                                                            onChange={this.handleChangePublish.bind(this)}
                                                                            value={publish}
                                                                            color="primary"
                                                                        />
                                                                    }
                                                                    label={publish ? Translate.published : Translate.draft}
                                                                />
                                                            }
                                                        >
                                                            {Translate.publishStatus}
                                                        </Alert>
                                                    </Grid>
                                                }
                                                <Grid item xs={12}>
                                                    <TextField
                                                        margin="normal"
                                                        required
                                                        fullWidth
                                                        variant="outlined"
                                                        name="title"
                                                        label={Translate.contentTitle}
                                                        type="text"
                                                        id="title"
                                                        size="small"
                                                        value={fields.title}
                                                        onChange={this.handleChange.bind(this)}
                                                        error = {!!errors['title']}
                                                        helperText={errors['title']}
                                                    />
                                                </Grid>
                                                <Grid item xs={12}>
                                                    <RichEditor ref={this.EditorChild} Output={this.handleOutPut.bind(this)} input={content.RAW}/>
                                                </Grid>
                                                <Grid item xs={12}>
                                                    <TextField
                                                        variant="outlined"
                                                        margin="normal"
                                                        multiline
                                                        fullWidth
                                                        name="description"
                                                        label={Translate.seoDescription}
                                                        placeholder={Translate.seoDescription}
                                                        type="text"
                                                        id="description"
                                                        rows="4"
                                                        value={fields.description}
                                                        onChange={this.handleChange.bind(this)}
                                                        onClick={this.handleClickDescription.bind(this)}
                                                        error = {!!errors['description']}
                                                        helperText={errors['description']}
                                                    />
                                                    <FieldCounter length={fields.description.length} max={150}/>
                                                </Grid>
                                                <Grid item xs={12}>
                                                    <Keywords input={keywords} handleChange={(keywords) => this.setState({keywords})}/>
                                                    <Typography
                                                        variant="body2"
                                                        style={{marginTop: 10,fontWeight:700}}
                                                    >
                                                        {Translate.keywordsDescription}
                                                    </Typography>
                                                    <Typography>
                                                        {Translate.pressEnterAfterEachKeyword}
                                                    </Typography>
                                                </Grid>
                                                <Hidden smDown>
                                                <Grid item xs={12}>
                                                    <LoadingButton
                                                        variant="contained"
                                                        color="primary"
                                                        onClick = {this.handleSubmit.bind(this)}
                                                        loading = {SubmitLoading}
                                                    >
                                                        {editMode ? Translate.editContent : Translate.makeContent}
                                                    </LoadingButton>
                                                </Grid>
                                                </Hidden>
                                            </Grid>
                                    }
                                </AppCard>
                            </Grid>
                            <Grid item xs={12} md={4} lg={3}>
                                <Grid container spacing={2} alignItems="center">
                                    <Grid item xs={12}>
                                        <AppCard>
                                            {
                                                this.state.loading ? <AppCardLoaderFields/> :
                                                    <Grid container spacing={2} alignItems="center">
                                                        <Grid item xs={12}>
                                                            <Typography color="textSecondary"
                                                                        style={{marginBottom: 0}}> </Typography>
                                                        </Grid>
                                                        <Hidden smDown>
                                                        <Grid item xs={12} style={{paddingTop: 0}}>
                                                            <LoadingButton
                                                                variant="contained"
                                                                color="primary"
                                                                style={{width: "100%"}}
                                                                onClick={this.handleSubmit.bind(this)}
                                                                loading={SubmitLoading}
                                                            >
                                                                {editMode ? Translate.editContent : Translate.makeContent}
                                                            </LoadingButton>
                                                        </Grid>
                                                        </Hidden>
                                                        <Grid item xs={12}>
                                                            <SubTitle>{Translate.ThumbnailTitle}</SubTitle>
                                                            <Thumbnail rounded ref={this.ThumbChild}
                                                                       handleThumbImage={this.handleThumbImage.bind(this)}
                                                                       initial={thumbnail}/>
                                                        </Grid>
                                                    </Grid>
                                            }
                                        </AppCard>
                                    </Grid>
                                <Grid item xs={12}>
                                    <AppCard>
                                        {
                                            this.state.loading ?
                                                <AppCardLoaderFields/>
                                            :
                                                <CategoryHolderPro outPut={this.handleCategoryHolder.bind(this)} inPut={categories}/>
                                        }
                                    </AppCard>
                                </Grid>
                                    <Hidden mdUp>
                                        <Grid item xs={12} style={{paddingTop: 0}}>
                                            <LoadingButton
                                                variant="contained"
                                                color="primary"
                                                style={{width: "100%"}}
                                                onClick={this.handleSubmit.bind(this)}
                                                loading={SubmitLoading}
                                            >
                                                {editMode ? Translate.editContent : Translate.makeContent}
                                            </LoadingButton>
                                        </Grid>
                                    </Hidden>
                            </Grid>
                        </Grid>
                        </Grid>
                }
            </AppAnimate>

        );
    }
}

export default withSnackbar(withRouter(withStyles(Styles)(MakeContent)));